import { useEffect, useState, useCallback } from "react";
export default function usePopupRotation() {
  const [selectedPopup, setSelectedPopup] = useState(null);
  const [popupShown, setPopupShown] = useState(false);
  const [popupClosed, setPopupClosed] = useState(false);

  const pickRandomPopup = useCallback(async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_URL}/getpopups`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sitekey: process.env.REACT_APP_SITE_KEY }),
        }
      );

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const response = await res.json();

      const now = new Date();

      const validPopups = response.data.popups.filter((item) => {
        const publishDate = item.publishDate ? new Date(item.publishDate) : now;
        const archiveDate = item.archiveDate
          ? new Date(item.archiveDate)
          : new Date("2999-12-31");
        return now >= publishDate && now <= archiveDate;
      });

      let shownPopups = JSON.parse(localStorage.getItem("shownPopups")) || [];
      let remaining = validPopups.filter((p) => !shownPopups.includes(p._id));

      if (!remaining.length) {
        shownPopups = [];
        localStorage.setItem("shownPopups", JSON.stringify([]));
        remaining = validPopups;
      }

      const randomIndex = Math.floor(Math.random() * remaining.length);
      const chosen = remaining[randomIndex];

      localStorage.setItem(
        "shownPopups",
        JSON.stringify([...shownPopups, chosen._id])
      );

      setSelectedPopup(chosen);
    } catch (error) {
      console.error("Popup fetch error:", error);
    }
  }, []);

  // ⏰ Show popup after 30 seconds if not closed
  useEffect(() => {
    if (popupClosed) return;

    const timer = setTimeout(() => {
      setPopupShown(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, [popupClosed]);

  // 🖱️ Scroll-triggered popup if not closed
  useEffect(() => {
    if (popupClosed) return;

    let timeout;

    const handleScroll = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (popupShown || popupClosed) return;

        const scrollTop = window.scrollY;
        const docHeight =
          document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;

        if (scrollPercent >= 30) setPopupShown(true);
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, [popupShown, popupClosed]);

  // Initial load
  useEffect(() => {
    pickRandomPopup();
  }, [pickRandomPopup]);

  // ✅ Close popup handler
  const handleClosePopup = () => {
    setPopupClosed(true);
    setPopupShown(false);
  };

  return { selectedPopup, popupShown, handleClosePopup };
}
